<template>
    <PopupRouterView :showLeftIcon="true" label="Lookup Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="lookup"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="lookupInput">


        <b-card header="Lookup" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Lookup Details"
			:bordered="true" :items="lookupDetails" 
			:fields="fieldsLookupDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByLookupDetail" 
			:sort-desc.sync="sortDescLookupDetail" small responsive	
			@editButtonMethod="editRowDataLookupDetail"	
			@deleteButtonMethod="deleteRowDataLookupDetail"	
			@showPopupAddMethod="addDataLookupDetail()"	
			@showPopupUploadMethod="showPopupUploadLookupDetail()"
			@downloadMethod="downloadLookupDetail()"
			@addFromClipboardMethod="addFromClipboardLookupDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardLookupDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadLookupDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowLookupDetailFilter = !isShowLookupDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowLookupDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Name">
					<b-form-input id="input-lookup-details-name-table" v-model="filterLookupDetail.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Value">
					<b-form-input id="input-lookup-details-value-table" v-model="filterLookupDetail.value" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Editable">
					<b-form-checkbox id="input-lookup-details-is-editable-table" class="float-right" v-model="filterLookupDetail.isEditable"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( lookupDetailPageSize * (currentLookupDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(name)="row">
				<app-input-textbox :id="'input-lookup-details-name-' + row.index" label-cols-lg="12" label="Name" size="sm" :model.sync="row.item.name" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   @change="saveInputLookupDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(value)="row">
				<app-input-textbox :id="'input-lookup-details-value-' + row.index" label-cols-lg="12" label="Value" size="sm" :model.sync="row.item.value"   @change="saveInputLookupDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(isEditable)="row">
				<app-input-checkbox :id="'input-lookup-details-is-editable-row-' + row.index" label-cols-lg="12" label="Is Editable" :model.sync="row.item.isEditable" @change="saveInputLookupDetail(row.item)" :isUpdatable ="null"  :nolabel="true"></app-input-checkbox>
			</template>

								
			<template v-slot:form-add-detail>
				<LookupDetailInput 
					:model="modelLookupDetail"
					:openPopup="isShowPopupLookupDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataLookupDetail"/>
			</template>
			<template v-slot:upload-detail>
					<LookupDetailUpload
					:openPopup="isShowPopupUploadLookupDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataLookupDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentLookupDetailPage"
				:total-rows="totalLookupDetailRow"
				:per-page="lookupDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Lookup from '@/models/Lookup/Lookup';
import LookupList from '@/models/Lookup/LookupList';
import LookupFilter from '@/filters/Lookup/LookupFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import LookupDetail from '@/models/Lookup/LookupDetail';
import LookupDetailFilter from '@/filters/Lookup/LookupDetailFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import LookupDetailInput from '@/views/Lookup/LookupDetailInput';
import LookupDetailUpload from '@/views/Lookup/LookupDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputCheckbox,
		LookupDetailInput,LookupDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsLookupDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"name": { "class" : "th-name first-child", "label" : "Name", key: 'name', sortable: false}}, 
				{"value": { "class" : "th-value", "label" : "Value", key: 'value', sortable: false}}, 
				{"isEditable": { "class" : "th-is-editable last-child", "label" : "Is Editable", key: 'isEditable', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelLookupDetail : {},
			isShowPopupLookupDetail : false,
			isShowPopupUploadLookupDetail : false,
			filterLookup : null,
			currentLookupPage : 1,
			lookupPageSize: 10,
			sortByLookup: '',
			sortDescLookup: '',
			filterLookupDetail : null,
			currentLookupDetailPage : 1,
			lookupDetailPageSize: 10,
			sortByLookupDetail: '',
			sortDescLookupDetail: '',
			sortingByLookupDetail: [],
			lookupDetails : [],
			lookupDetailId : '',
			totalLookupDetailRow : 0,
			isShowLookupDetailFilter: false,
			isDownloadLookupDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isLookupComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getLookup : async function(id) {
			this.isBusy = true;
			Lookup.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadLookup = true;
			this.filterLookup.id = this.modelId;
			Lookup.downloadDataDetail(this, this.filterLookup).then(result => {
				this.isDownloadLookup = false;
			}).catch(error => { this.isDownloadLookup = false; })
		},
		getLookupDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterLookupDetail);
			if (this.modelId == null) return;
			filter.lookupId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByLookupDetail != null) {
				this.sortingByLookupDetail[this.sortByLookupDetail] = this.sortDescLookupDetail;
			}
			let currentPage = (this.currentLookupDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalLookupDetailRow + 1;
				let page = Math.ceil(totalData/this.lookupDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.lookupDetailPageSize = 0;
			// disable paging end
			LookupDetail.getList(this, filter, this.sortingByLookupDetail, currentPage , this.lookupDetailPageSize).then(result => {
				this.currentLookupDetailPage = currentPage + 1;
				this.lookupDetails = result.data;
				this.totalLookupDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getLookups : async function(input) {
			let filter = new LookupFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isLookupComboLoading = true;
			Lookup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lookups = result.data
				}
				this.isLookupComboLoading = false;
			})
			.catch(error => {});
		},
		getLookups : async function(input) {
			let filter = new LookupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isLookupComboLoading = true;
			Lookup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lookups = result.data
				}
				this.isLookupComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.lookupInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					Lookup.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'lookupindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					Lookup.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'lookupindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Lookup.updateData(this, model, id)
					.catch((error) => {
						this.getLookup(id);
					});
				}
			});
		},
		onHidden() {
			this.getLookups();
		},
		addRowDataLookupDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.lookupId =  this.modelId;
					LookupDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getLookupDetails(true);
						this.isShowPopupLookupDetail = false;
					})
				} else {
					model.lookupId =  this.modelId;
					LookupDetail.createDataDetail(this, model)
					.then(result => {
						this.getLookupDetails(true);
						this.isShowPopupLookupDetail = false;
					})
				}
			}
		},
		async editRowDataLookupDetail(id) {
			this.lookupDetailId = id;
			this.isShowPopupLookupDetail = true; 
		},
		async deleteRowDataLookupDetail(id) {
			LookupDetail.deleteData(this, id).then(result => { this.getLookupDetails(); });
		},
		async resetDataLookupDetail() {
			this.lookupDetailId = "";
			this.isShowPopupLookupDetail = true;
		},
		async addDataLookupDetail() {
			LookupDetail.createData(this, { lookupId: this.modelId })
			.then(result => {
				this.getLookupDetails(true);
			})
		},
		async addFromClipboardLookupDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, lookupId: this.modelId });
				});
				LookupDetail.addFromClipboard(this, names).then(result => { this.getLookupDetails() });
			});
		},
		async replaceFromClipboardLookupDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, lookupId: this.modelId });
				});
				LookupDetail.replaceFromClipboard(this, names).then(result => { this.getLookupDetails() });
			});   
		},
		showPopupUploadLookupDetail() {
			if(this.lookupDetails != null && this.lookupDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap LookupDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadLookupDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadLookupDetail = true;
			}
		},
		uploadDataLookupDetail(modalEvent, newDatas) {
			this.isShowPopupUploadLookupDetail = false; 
		},
		downloadLookupDetail(modalEvent) {
			this.isDownloadLookupDetail = true;
			this.filterLookupDetail.lookupId = this.modelId;
			LookupDetail.downloadDataDetail(this, this.filterLookupDetail).then(result => {
				this.isDownloadLookupDetail = false;
			}).catch(error => { this.isDownloadLookupDetail = false; })
		},
		saveInputLookupDetail(item) {
			if (this.lookups != null && this.lookups != undefined  && this.lookups.length > 0) {
				item.lookup = this.lookups.find(q => q.id == item.lookupId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					LookupDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadLookupDetail = false; 
			this.isShowPopupLookupDetail = false; 
			if (modalType == 'LookupDetail') {
				this.getLookupDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowLookupDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterLookup = new LookupFilter();
		this.filterLookupDetail = new LookupDetailFilter();
		//this.getLookups();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getLookup(id);
			} else {
				this.modelId = id;
				this.getLookup(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByLookupDetail : {
			handler: function() {
				this.getLookupDetails();
			}
		},
		sortDescLookupDetail: {
			handler: function() {
				this.getLookupDetails();
			}
		},
		currentLookupDetailPage: {
			handler: function() {
				this.getLookupDetails();
			}
		},
		lookupDetailPageSize : {
			handler: function() {
				this.getLookupDetails();
			}
		},
		filterLookupDetail: {
			handler: function() {
				this.getLookupDetails();
			},
			deep: true,
		},
	},
}
</script>
